export const MessageUnreadIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Message unread icon</title>
      <path
        d="M15 4.5H4.125C3.62772 4.5 3.15081 4.69754 2.79917 5.04917C2.44754 5.40081 2.25 5.87772 2.25 6.375V17.625C2.25 18.1223 2.44754 18.5992 2.79917 18.9508C3.15081 19.3025 3.62772 19.5 4.125 19.5H19.8155C20.3128 19.5 20.7897 19.3025 21.1413 18.9508C21.4929 18.5992 21.6905 18.1223 21.6905 17.625V11.2031"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 7.5L12 12.75L16.0781 9.67172"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.2477 8.24922C21.489 8.24922 22.4953 7.24291 22.4953 6.00156C22.4953 4.76022 21.489 3.75391 20.2477 3.75391C19.0063 3.75391 18 4.76022 18 6.00156C18 7.24291 19.0063 8.24922 20.2477 8.24922Z"
        fill="black"
      />
      <path
        d="M20.2516 8.99922C19.6587 8.99922 19.0791 8.82341 18.5862 8.49402C18.0932 8.16464 17.709 7.69647 17.4821 7.14872C17.2552 6.60097 17.1958 5.99824 17.3115 5.41675C17.4272 4.83526 17.7127 4.30113 18.1319 3.8819C18.5511 3.46267 19.0853 3.17717 19.6668 3.06151C20.2482 2.94584 20.851 3.00521 21.3987 3.23209C21.9465 3.45898 22.4146 3.84319 22.744 4.33616C23.0734 4.82912 23.2492 5.40868 23.2492 6.00156C23.2486 6.7964 22.9326 7.55851 22.3705 8.12054C21.8085 8.68258 21.0464 8.9986 20.2516 8.99922ZM20.2516 4.50391C19.9548 4.50344 19.6646 4.59102 19.4176 4.75556C19.1706 4.9201 18.978 5.15421 18.8641 5.42826C18.7502 5.7023 18.7201 6.00398 18.7778 6.2951C18.8354 6.58623 18.978 6.85372 19.1877 7.06374C19.3974 7.27375 19.6647 7.41684 19.9557 7.47491C20.2468 7.53298 20.5485 7.50341 20.8227 7.38995C21.0969 7.27649 21.3313 7.08423 21.4963 6.83751C21.6612 6.59078 21.7492 6.30068 21.7492 6.00391C21.7492 5.60649 21.5915 5.22531 21.3107 4.94408C21.0299 4.66284 20.649 4.50453 20.2516 4.50391Z"
        fill="black"
      />
    </svg>
  );
};
